unit UrlbAntragEdit;

interface

uses System.SysUtils, System.Classes, JS, Web, WebBasis, WEBLib.Graphics, WEBLib.Controls, XData.Web.Client,
     WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB,
     XData.Web.JsonDataset, XData.Web.Dataset, VCL.TMSFNCCustomComponent, VCL.TMSFNCBitmapContainer, VCL.TMSFNCTypes,
     VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCCustomControl, VCL.TMSFNCToolBar, WEBLib.Grids;

[async]  function DoUrlbAntragEdit( var aID_UrlbAntrag : Integer ) : TModalResult; async;

type
  TfrmUrlbAntragEdit = class(TfrmWebBasis)
    WebPanel1: TPanel;
    lbMaBstCaption: TLabel;
    lbEntladung: TLabel;
    lbMitarbeiter: TLabel;
    WebLabel3: TLabel;
    lbStatus: TLabel;
    WebLabel2: TLabel;
    btnOK: TTMSFNCToolBarButton;
    btnAbbrechen: TTMSFNCToolBarButton;
    WebPanel2: TPanel;
    WebLabel4: TLabel;
    WebLabel1: TLabel;
    WebLabel5: TLabel;
    dtBeginn: TDateTimePicker;
    dtEnde: TDateTimePicker;
    edtInfoText: TEdit;
    cbxSchulpfKinder: TCheckBox;
    cbxUnbezUrlaub: TCheckBox;
    cbxHalbeTage: TCheckBox;
    respGrid: TResponsiveGrid;
    procedure btnOKClick(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormResize(Sender: TObject);

     //
    [async] procedure WebFormShow(Sender: TObject); async;
    [async] procedure Daten_Laden; async;
    [async] function  Daten_Speichern : Integer; async;
    [async] procedure Form_Uebersetzen; async;
     //

  private
    iID_UrlbAntrag  : Integer;
    iID_Akt  : Integer;
    procedure Form_Anpassen;
    procedure Opt_Speichern;
    procedure Opt_Laden;
    procedure Set_Deaktiv;

  public

  protected procedure LoadDFMValues; override; end;

var frmUrlbAntragEdit: TfrmUrlbAntragEdit;

implementation

{$R *.dfm}

uses UnitMain, Konstanten, GlobalWeb, SpediFucsDatenmodul;


//================================================================================================//

function DoUrlbAntragEdit( var aID_UrlbAntrag : Integer ) : TModalResult;
begin

  frmMainForm.mMainMenu.Enabled := False;

  frmUrlbAntragEdit := TfrmUrlbAntragEdit.Create(application);
  frmUrlbAntragEdit.Popup   := True;

  frmUrlbAntragEdit.iID_UrlbAntrag  := aID_UrlbAntrag;

  // used to manage Back button handling to close subform
  window.location.hash := 'subform';

  await( TfrmUrlbAntragEdit, frmUrlbAntragEdit.Load() );  //load file HTML template + controls      macht CreateForm und FormShow

  frmUrlbAntragEdit.Resize;

  Try
    await( TModalResult, frmUrlbAntragEdit.Execute);  // excute form and wait for close

    Result := frmUrlbAntragEdit.ModalResult;

    // Änderungen speichern
    If Result = mrOK then
      Begin
        await( frmUrlbAntragEdit.Daten_Speichern );
        aID_UrlbAntrag := frmUrlbAntragEdit.iID_UrlbAntrag;
      End;
//
  Finally
    frmUrlbAntragEdit.Free;
  End;


  frmMainForm.mMainMenu.Enabled := True;

end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.Opt_Speichern;
begin

  //TWebLocalStorage.SetValue( cFormSchadenEdit+'PAGE', IntToStr(pgContr.ActivePageIndex) );

end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.Opt_Laden;
begin
 //  pgContr.ActivePageIndex := StrToIntDef( TWebLocalStorage.GetValue( cFormSchadenEdit+'PAGE' )  ,0);

end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.btnOKClick(Sender: TObject);
begin
  inherited;
  If Sender = btnOK then ModalResult := mrOK
  Else ModalResult := mrCancel;

  Close;
end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.Daten_Laden;
var Response: TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sDaten, sFelder, sSQL, sTmp, sMng, sEnh, sText, sTag, sFarbe, sEntscheidung, sEntscheider, sHT, sWoTag, sBemerkung : String;
    aSL, aSL_Daten : TStringList;
    aStream : TStream;
    aTMP :  TJSObject;
    i, iAnz, iAnzDok, iTop, iTmp, iID_Standort : Integer;
    bBeendet, bIstEntscheidungVorh : Boolean;
    aGuiObj :  TCoreGuiObj;
    aItem : TResponsiveGridItem;
begin

  console.log('TfrmUrlbAntragEdit.Daten_Laden - Start '+IntToStr(self.iID_UrlbAntrag) );

  If not WaitMessage.Showing then WaitMessage.Show;


    sSQL := '01:SELECT A.ID_MITARBEITER, A.BEGINN, A.ENDE, A.ID_STATUS, A.INFOTEXT, BEENDET, SCHULKINDER, UNBEZAHLT, '
           +' (SELECT NAME1 || IIF(NAME2 is null,'+cH+cH+', '+cH+', '+cH+' || NAME2 ) '
           +'  FROM ADRESSE A WHERE M.ID_ADRESSE=A.ID_ADRESSE  ) AS MITARBEITER '
           +'  FROM URLB_ANTRAG A, MITARBEITER M  WHERE A.ID_MITARBEITER=M.ID_MITARBEITER '
           +'  AND A.ID_URLB_ANTRAG='+ IntToStr( self.iID_UrlbAntrag ) +';'
           +'02:SELECT P.*, EXTRACT( WEEKDAY FROM DATUM) AS WOTAG  FROM URLB_ANTRAG_POS P '
           +  ' WHERE ID_URLB_ANTRAG='+IntToStr(self.iID_UrlbAntrag) +' ORDER BY DATUM '
       ;


  sSQL := await(  Crypt( sSQL )  );

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;
    Response :=  await( ClientConn.RawInvokeAsync('ISystemService.GetDatenPaket', [ sSQL,1,50 ] ) );
    Blob := Response.Result;
    asm sDaten = await Blob.text(); end;
  ClientConn.Free;

  aSL_Daten := TStringList.Create;
  aSL_Daten.Text := await( Crypt( sDaten ));

  aSL := TStringList.Create;

  lbMitarbeiter.Caption := frmMainForm.BenutzerMaZuname+', '+frmMainForm.BenutzerMaVorname;

  cbxHalbeTage.Visible := (self.iID_UrlbAntrag = 0);

  bBeendet := False;

  // Urlaubsantrag ---------------------------------------------------------
  //
  If self.iID_UrlbAntrag = 0 then
    Begin
      lbMaBstCaption.Caption := 'anlegen...';
      lbStatus.Caption := '';
      edtInfoText.Text := '';
      dtBeginn.DateTime := Date;
      dtEnde.DateTime   := Date;
    End
  Else
    Begin
      lbMaBstCaption.Caption := 'bearbeiten...';

      iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '01');
      sFelder := aSL[1];
      sDaten  := aSL[2];

      lbStatus.Caption    := Get_UrlbAntragStatus( SToI( GetFeldWert( sFelder, sDaten, 'ID_STATUS' ))  );;

      dtBeginn.DateTime := StrToDateTime(  GetFeldWert( sFelder, sDaten, 'BEGINN' )  );
      dtEnde.DateTime   := StrToDateTime(  GetFeldWert( sFelder, sDaten, 'ENDE' )  );

      edtInfoText.Text := GetFeldWert( sFelder, sDaten, 'INFOTEXT'  );

      cbxSchulpfKinder.Checked := SToB( GetFeldWert( sFelder, sDaten, 'SCHULKINDER') );
      cbxUnbezUrlaub.Checked   := SToB( GetFeldWert( sFelder, sDaten, 'UNBEZAHLT') );

      bBeendet := SToB( GetFeldWert( sFelder, sDaten, 'BEENDET') );

      If bBeendet then Set_Deaktiv;

    End;


  bIstEntscheidungVorh := False;

  // Positionen laden, deaktiviere falls schon Entscheidungen da sind
  //
  iAnz := dmSpediFucs.Get_PaketDaten( aSL_Daten, aSL, '02');
  sFelder := aSL[1];
  If iAnz>2 then
  For i := 2 to aSL.Count -1 Do
    Begin
      sDaten  := aSL[i];
      sTag   := GetFeldWert( sFelder, sDaten, 'DATUM');
      sWoTag := GetFeldWert( sFelder, sDaten, 'WOTAG');
      sWoTag := Get_WoTag_By_Nr( sWoTag );
      sTag := sTag + ' ' +sWoTag;

      sHT := GetFeldWert( sFelder, sDaten, 'HALBTAG');
      If sHT='1' then sTag := sTag +' [H]';
      sTag := sTag + ' ';

      sTmp := GetFeldWert( sFelder, sDaten, 'ENTSCHIEDEN');
      iTmp := SToI(sTmp);
      If iTmp > 0 then bIstEntscheidungVorh := True;
      sEntscheidung := Get_UrlbAntragEntscheidung( SToI(sTmp) );
      sEntscheider  := ' '+ GetFeldWert( sFelder, sDaten, 'ENTSCHIEDEN_USER') ;
      sBemerkung    := GetFeldWert( sFelder, sDaten, 'BEMERKUNG');

      Case iTmp of
        1 : sFarbe := '#339966'; // '#339966';
        2 : sFarbe := '#ff0000'; // '#ff6600';
        3 : sFarbe := '#999999';
      End;

      sText :='<p><strong>'+sTag +'</strong> <span style="background-color: '+sFarbe+'; color: #ffffff;"><strong>'
             +sEntscheidung+'</strong></span>'+sEntscheider+'<br />'+sBemerkung+'</p>';

      aItem := respGrid.Items.Add;
      aItem.HTML := sText;
      aItem.Tag :=  StrToIntDef(  GetFeldWert( sFelder, sDaten, 'ID_URLB_ANTRAG_POS')  ,0);

    End;

  If bIstEntscheidungVorh  then self.Set_Deaktiv;

  aSL.Free;
  aSL_Daten.Free;

  If not bUebersetzt then Form_Uebersetzen;

  WaitMessage.Hide;

  console.log('TfrmUrlbAntragEdit.Daten_Laden - Ende '+IntToStr(self.iID_UrlbAntrag) );

end;

//================================================================================================//

function TfrmUrlbAntragEdit.Daten_Speichern : Integer;
var Response : TXDataClientResponse;
    ClientConn: TXDataWebClient;
    Blob: JSValue;
    sSQL, sBezeich : String;
    aObj : TParam;
    iErg, iAnz : Integer;
begin


  If self.iID_UrlbAntrag=0 then
    Begin
      aObj := TParam.Create;
      aObj.ID_Mab  := StrToIntDef( frmMainForm.BenutzerMaNr,0);
      aObj.Datum1  := dtBeginn.DateTime;
      aObj.Datum2  := dtEnde.DateTime;
      aObj.ID_Mab  := SToI(frmMainForm.BenutzerMaNr);
      aObj.String1 := frmMainForm.User_Account;
      aObj.Integer1 := BToI(cbxHalbeTage.Checked);

       ClientConn := TXDataWebClient.Create(nil);
       ClientConn.Connection := frmMainForm.XDataConn;

       Response := await( ClientConn.RawInvokeAsync('ISystemService.UrlbAntragIns', [ aObj] ));

       iErg := JS.ToInteger(TJSObject(Response.Result)['value']);

       self.iID_UrlbAntrag := iErg;

      ClientConn.Free;

      console.log('angelegt...' +Inttostr(self.iID_UrlbAntrag)   );

    End;


  console.log(sSQL + 'jetzt upgedaten...');

  iAnz := Trunc(dtEnde.DateTime) -  Trunc(dtBeginn.DateTime) +1;

  sSQL := 'UPDATE URLB_ANTRAG SET '
        +' BEGINN = '+DToS( dtBeginn.DateTime ) +', '
        +' ENDE   = '+DToS( dtEnde.DateTime )   +', '
        +' ANZTAGE = '+IntToStr(iAnz)  +', '
        +' INFOTEXT = '+cH+Trim(edtInfoText.Text)+cH  +', '
        +' SCHULKINDER = '+BToS(cbxSchulpfKinder.Checked)  +', '
        +' UNBEZAHLT = '+BToS(cbxUnbezUrlaub.Checked)
        +' WHERE ID_URLB_ANTRAG='+IntToStr(self.iID_UrlbAntrag)  +';' ;

  aObj := TParam.Create;
  aObj.Integer1 :=  self.iID_UrlbAntrag;
  aObj.Integer2 := BToI(cbxHalbeTage.Checked);
  aObj.String1 := frmMainForm.User_Account;

  ClientConn := TXDataWebClient.Create(nil);
  ClientConn.Connection := frmMainForm.XDataConn;

  sSQL := await( Crypt( sSQL ));

  Response := await( ClientConn.RawInvokeAsync('ISystemService.SetDatenPaket', [ sSQL ] ) );
  Blob := Response.Result;


  Response := await( ClientConn.RawInvokeAsync('ISystemService.UrlbAntragTageUpd', [ aObj] ));
  Blob := Response.Result;

  ClientConn.Free;

  aObj.Free;

  console.log(sSQL + 'upgedatet...');

end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.Set_Deaktiv;
begin

  btnOK.Enabled := False;
  dtBeginn.Enabled := False;
  dtEnde.Enabled := False;

  cbxSchulpfKinder.Enabled := False;
  cbxUnbezUrlaub.Enabled := False;
  cbxHalbeTage.Enabled := False;
  edtInfoText.Enabled := False;


end;


//====================================================================================================================//

procedure TfrmUrlbAntragEdit.WebFormClose(Sender: TObject; var Action: TCloseAction);
begin
  Opt_Speichern;
  inherited;

end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.WebFormCreate(Sender: TObject);
begin
  inherited;

  iID_Akt := 0;


  Opt_Laden;

end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.WebFormResize(Sender: TObject);
begin
  inherited;
  Form_Anpassen;
end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.WebFormShow(Sender: TObject);
begin
  inherited;

  WaitMessage.Show;

  Sprach_Daten_Laden('URLBANTRAGEDIT', frmMainForm.iID_Sprache );

  Daten_Laden;

  Form_Anpassen;

end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.Form_Anpassen;
var iZielBreite : Integer;
begin

  // Form
  self.Left   := 0;
  self.Top    := frmMainForm.pnlMenu.Top;
  self.Width  := window.InnerWidth;
  self.Height := window.InnerHeight-self.Top;



  // Komponenten
   iZielBreite := Trunc( self.Width * 0.95 );
   If iZielBreite > 500 then iZielBreite := 500;

   lbMitarbeiter.Width := iZielBreite - lbMitarbeiter.Left;

   Console.Log('>> Form_Anpassen');

end;


procedure TfrmUrlbAntragEdit.Form_Uebersetzen;
begin

  If not tabSprachDaten.Active then
    Begin
     console.Log( 'Form_Uebersetzen in TfrmUrlbAntragEdit -> NICHT OFFFEN');
     Exit;
    End;

  //console.Log( 'Form_Uebersetzen in TfrmUrlbAntragEdit');

//  If tabSprachDaten.Locate('NUMMER', 10, [] ) then lbTau.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
  //If tabSprachDaten.Locate('NUMMER', 20, [] ) then lbNummer.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 30, [] ) then lbBeladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 40, [] ) then lbEntladung.Caption    := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 50, [] ) then pgContr.Pages[0].Text := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 60, [] ) then pgContr.Pages[1].Text := tabSprachDatenBEGRIFF_UEB.AsString;
//  If tabSprachDaten.Locate('NUMMER', 70, [] ) then pgContr.Pages[2].Text := tabSprachDatenBEGRIFF_UEB.AsString;

//  If tabSprachDaten.Locate('NUMMER', 120, [] ) then btnAbbrechen.Text := tabSprachDatenBEGRIFF_UEB.AsString;


 self.bUebersetzt := True;


end;

//====================================================================================================================//

procedure TfrmUrlbAntragEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  lbMaBstCaption := TLabel.Create(Self);
  lbEntladung := TLabel.Create(Self);
  lbMitarbeiter := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  lbStatus := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  btnOK := TTMSFNCToolBarButton.Create(Self);
  btnAbbrechen := TTMSFNCToolBarButton.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  dtBeginn := TDateTimePicker.Create(Self);
  dtEnde := TDateTimePicker.Create(Self);
  edtInfoText := TEdit.Create(Self);
  cbxSchulpfKinder := TCheckBox.Create(Self);
  cbxUnbezUrlaub := TCheckBox.Create(Self);
  cbxHalbeTage := TCheckBox.Create(Self);
  respGrid := TResponsiveGrid.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  lbMaBstCaption.BeforeLoadDFMValues;
  lbEntladung.BeforeLoadDFMValues;
  lbMitarbeiter.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  lbStatus.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  dtBeginn.BeforeLoadDFMValues;
  dtEnde.BeforeLoadDFMValues;
  edtInfoText.BeforeLoadDFMValues;
  cbxSchulpfKinder.BeforeLoadDFMValues;
  cbxUnbezUrlaub.BeforeLoadDFMValues;
  cbxHalbeTage.BeforeLoadDFMValues;
  respGrid.BeforeLoadDFMValues;
  tabSprachDaten.BeforeLoadDFMValues;
  try
    Width := 580;
    Height := 659;
    Color := 16776441;
    Font.Charset := DEFAULT_CHARSET;
    Font.Height := -12;
    Font.Name := 'Segoe UI';
    SetEvent(Self, 'OnResize', 'WebFormResize');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 580;
    WebPanel1.Height := 119;
    WebPanel1.Align := alTop;
    WebPanel1.ChildOrder := 2;
    WebPanel1.Color := 16776441;
    WebPanel1.TabOrder := 2;
    lbMaBstCaption.SetParentComponent(WebPanel1);
    lbMaBstCaption.Name := 'lbMaBstCaption';
    lbMaBstCaption.Left := 157;
    lbMaBstCaption.Top := 24;
    lbMaBstCaption.Width := 88;
    lbMaBstCaption.Height := 18;
    lbMaBstCaption.Caption := 'bearbeiten';
    lbMaBstCaption.Font.Charset := DEFAULT_CHARSET;
    lbMaBstCaption.Font.Color := clBlack;
    lbMaBstCaption.Font.Height := -15;
    lbMaBstCaption.Font.Name := 'Verdana';
    lbMaBstCaption.Font.Style := [fsBold];
    lbMaBstCaption.HeightPercent := 100.000000000000000000;
    lbMaBstCaption.ParentFont := False;
    lbMaBstCaption.WidthPercent := 100.000000000000000000;
    lbEntladung.SetParentComponent(WebPanel1);
    lbEntladung.Name := 'lbEntladung';
    lbEntladung.Left := 16;
    lbEntladung.Top := 57;
    lbEntladung.Width := 71;
    lbEntladung.Height := 16;
    lbEntladung.Caption := 'Mitarbeiter';
    lbEntladung.Font.Charset := ANSI_CHARSET;
    lbEntladung.Font.Color := clWindowText;
    lbEntladung.Font.Height := -13;
    lbEntladung.Font.Name := 'Verdana';
    lbEntladung.Font.Style := [];
    lbEntladung.HeightPercent := 100.000000000000000000;
    lbEntladung.ParentFont := False;
    lbEntladung.WidthPercent := 100.000000000000000000;
    lbMitarbeiter.SetParentComponent(WebPanel1);
    lbMitarbeiter.Name := 'lbMitarbeiter';
    lbMitarbeiter.Left := 106;
    lbMitarbeiter.Top := 57;
    lbMitarbeiter.Width := 71;
    lbMitarbeiter.Height := 16;
    lbMitarbeiter.Caption := 'T0000000';
    lbMitarbeiter.Font.Charset := ANSI_CHARSET;
    lbMitarbeiter.Font.Color := clWindowText;
    lbMitarbeiter.Font.Height := -13;
    lbMitarbeiter.Font.Name := 'Verdana';
    lbMitarbeiter.Font.Style := [fsBold];
    lbMitarbeiter.HeightPercent := 100.000000000000000000;
    lbMitarbeiter.ParentFont := False;
    lbMitarbeiter.WidthPercent := 100.000000000000000000;
    WebLabel3.SetParentComponent(WebPanel1);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 16;
    WebLabel3.Top := 82;
    WebLabel3.Width := 50;
    WebLabel3.Height := 16;
    WebLabel3.Caption := 'Status:';
    WebLabel3.Color := 16776441;
    WebLabel3.Font.Charset := ANSI_CHARSET;
    WebLabel3.Font.Color := clWindowText;
    WebLabel3.Font.Height := -13;
    WebLabel3.Font.Name := 'Verdana';
    WebLabel3.Font.Style := [];
    WebLabel3.HeightPercent := 100.000000000000000000;
    WebLabel3.ParentFont := False;
    WebLabel3.WidthPercent := 100.000000000000000000;
    lbStatus.SetParentComponent(WebPanel1);
    lbStatus.Name := 'lbStatus';
    lbStatus.Left := 106;
    lbStatus.Top := 82;
    lbStatus.Width := 65;
    lbStatus.Height := 16;
    lbStatus.Caption := 'Angelegt';
    lbStatus.Color := 16776441;
    lbStatus.Font.Charset := ANSI_CHARSET;
    lbStatus.Font.Color := clWindowText;
    lbStatus.Font.Height := -13;
    lbStatus.Font.Name := 'Verdana';
    lbStatus.Font.Style := [fsBold];
    lbStatus.HeightPercent := 100.000000000000000000;
    lbStatus.ParentFont := False;
    lbStatus.WidthPercent := 100.000000000000000000;
    WebLabel2.SetParentComponent(WebPanel1);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 157;
    WebLabel2.Top := 5;
    WebLabel2.Width := 116;
    WebLabel2.Height := 18;
    WebLabel2.Caption := 'Urlaubsantrag';
    WebLabel2.Font.Charset := DEFAULT_CHARSET;
    WebLabel2.Font.Color := clBlack;
    WebLabel2.Font.Height := -15;
    WebLabel2.Font.Name := 'Verdana';
    WebLabel2.Font.Style := [fsBold];
    WebLabel2.HeightPercent := 100.000000000000000000;
    WebLabel2.ParentFont := False;
    WebLabel2.WidthPercent := 100.000000000000000000;
    btnOK.SetParentComponent(WebPanel1);
    btnOK.Name := 'btnOK';
    btnOK.Left := 74;
    btnOK.Top := 5;
    btnOK.Width := 65;
    btnOK.Height := 44;
    btnOK.Cursor := crHandPoint;
    btnOK.ParentDoubleBuffered := False;
    btnOK.DoubleBuffered := True;
    btnOK.Font.Charset := ANSI_CHARSET;
    btnOK.Font.Color := clWindowText;
    btnOK.Font.Height := -13;
    btnOK.Font.Name := 'Verdana';
    btnOK.Font.Style := [];
    btnOK.ParentColor := True;
    btnOK.TabOrder := 0;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    btnOK.Text := '';
    btnOK.TextVisible := False;
    btnOK.Bitmaps.Clear;
    with btnOK.Bitmaps.Add do
    begin
      BitmapName := 'OK';
    end;
    btnOK.BitmapVisible := True;
    btnOK.BitmapContainer := BitmapCont;
    btnOK.ControlIndex := 0;
    btnAbbrechen.SetParentComponent(WebPanel1);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 3;
    btnAbbrechen.Top := 5;
    btnAbbrechen.Width := 65;
    btnAbbrechen.Height := 44;
    btnAbbrechen.Cursor := crHandPoint;
    btnAbbrechen.ParentDoubleBuffered := False;
    btnAbbrechen.DoubleBuffered := True;
    btnAbbrechen.Font.Charset := ANSI_CHARSET;
    btnAbbrechen.Font.Color := clWindowText;
    btnAbbrechen.Font.Height := -13;
    btnAbbrechen.Font.Name := 'Verdana';
    btnAbbrechen.Font.Style := [];
    btnAbbrechen.ParentColor := True;
    btnAbbrechen.TabOrder := 1;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnOKClick');
    btnAbbrechen.Text := '';
    btnAbbrechen.TextVisible := False;
    btnAbbrechen.Bitmaps.Clear;
    with btnAbbrechen.Bitmaps.Add do
    begin
      BitmapName := 'CANCEL';
    end;
    btnAbbrechen.BitmapVisible := True;
    btnAbbrechen.BitmapContainer := BitmapCont;
    btnAbbrechen.ControlIndex := 0;
    WebPanel2.SetParentComponent(Self);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 119;
    WebPanel2.Width := 580;
    WebPanel2.Height := 148;
    WebPanel2.Align := alTop;
    WebPanel2.ChildOrder := 11;
    WebPanel2.Color := 16776441;
    WebPanel2.TabOrder := 3;
    WebLabel4.SetParentComponent(WebPanel2);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 16;
    WebLabel4.Top := 93;
    WebLabel4.Width := 67;
    WebLabel4.Height := 16;
    WebLabel4.Caption := 'Info-Text:';
    WebLabel4.Color := 16776441;
    WebLabel4.Font.Charset := ANSI_CHARSET;
    WebLabel4.Font.Color := clWindowText;
    WebLabel4.Font.Height := -13;
    WebLabel4.Font.Name := 'Verdana';
    WebLabel4.Font.Style := [];
    WebLabel4.HeightPercent := 100.000000000000000000;
    WebLabel4.ParentFont := False;
    WebLabel4.WidthPercent := 100.000000000000000000;
    WebLabel1.SetParentComponent(WebPanel2);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 16;
    WebLabel1.Top := 16;
    WebLabel1.Width := 64;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Zeitraum:';
    WebLabel1.Color := 16776441;
    WebLabel1.Font.Charset := ANSI_CHARSET;
    WebLabel1.Font.Color := clWindowText;
    WebLabel1.Font.Height := -13;
    WebLabel1.Font.Name := 'Verdana';
    WebLabel1.Font.Style := [];
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.ParentFont := False;
    WebLabel1.WidthPercent := 100.000000000000000000;
    WebLabel5.SetParentComponent(WebPanel2);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 217;
    WebLabel5.Top := 16;
    WebLabel5.Width := 10;
    WebLabel5.Height := 15;
    WebLabel5.Caption := '--';
    WebLabel5.Color := 16776441;
    WebLabel5.HeightPercent := 100.000000000000000000;
    WebLabel5.WidthPercent := 100.000000000000000000;
    dtBeginn.SetParentComponent(WebPanel2);
    dtBeginn.Name := 'dtBeginn';
    dtBeginn.Left := 95;
    dtBeginn.Top := 10;
    dtBeginn.Width := 117;
    dtBeginn.Height := 28;
    dtBeginn.Cursor := crHandPoint;
    dtBeginn.BorderStyle := bsSingle;
    dtBeginn.ChildOrder := 5;
    dtBeginn.Color := 15329769;
    dtBeginn.Date := 45767.262767685180000000;
    dtBeginn.Role := '';
    dtBeginn.ShowSeconds := False;
    dtBeginn.Text := '';
    dtEnde.SetParentComponent(WebPanel2);
    dtEnde.Name := 'dtEnde';
    dtEnde.Left := 236;
    dtEnde.Top := 10;
    dtEnde.Width := 117;
    dtEnde.Height := 28;
    dtEnde.Cursor := crHandPoint;
    dtEnde.BorderStyle := bsSingle;
    dtEnde.ChildOrder := 5;
    dtEnde.Color := 15329769;
    dtEnde.Date := 45767.262767685180000000;
    dtEnde.Role := '';
    dtEnde.ShowSeconds := False;
    dtEnde.Text := '';
    edtInfoText.SetParentComponent(WebPanel2);
    edtInfoText.Name := 'edtInfoText';
    edtInfoText.Left := 18;
    edtInfoText.Top := 115;
    edtInfoText.Width := 335;
    edtInfoText.Height := 22;
    edtInfoText.ChildOrder := 13;
    edtInfoText.Font.Charset := ANSI_CHARSET;
    edtInfoText.Font.Color := clWindowText;
    edtInfoText.Font.Height := -13;
    edtInfoText.Font.Name := 'Verdana';
    edtInfoText.Font.Style := [];
    edtInfoText.HeightPercent := 100.000000000000000000;
    edtInfoText.MaxLength := 100;
    edtInfoText.ParentFont := False;
    edtInfoText.Text := 'edtInfoText';
    edtInfoText.WidthPercent := 100.000000000000000000;
    cbxSchulpfKinder.SetParentComponent(WebPanel2);
    cbxSchulpfKinder.Name := 'cbxSchulpfKinder';
    cbxSchulpfKinder.Left := 16;
    cbxSchulpfKinder.Top := 52;
    cbxSchulpfKinder.Width := 173;
    cbxSchulpfKinder.Height := 22;
    cbxSchulpfKinder.Cursor := crHandPoint;
    cbxSchulpfKinder.Caption := 'Schulpflichtige Kinder';
    cbxSchulpfKinder.ChildOrder := 14;
    cbxSchulpfKinder.Font.Charset := ANSI_CHARSET;
    cbxSchulpfKinder.Font.Color := clWindowText;
    cbxSchulpfKinder.Font.Height := -13;
    cbxSchulpfKinder.Font.Name := 'Verdana';
    cbxSchulpfKinder.Font.Style := [];
    cbxSchulpfKinder.HeightPercent := 100.000000000000000000;
    cbxSchulpfKinder.ParentFont := False;
    cbxSchulpfKinder.WidthPercent := 100.000000000000000000;
    cbxUnbezUrlaub.SetParentComponent(WebPanel2);
    cbxUnbezUrlaub.Name := 'cbxUnbezUrlaub';
    cbxUnbezUrlaub.Left := 213;
    cbxUnbezUrlaub.Top := 52;
    cbxUnbezUrlaub.Width := 167;
    cbxUnbezUrlaub.Height := 22;
    cbxUnbezUrlaub.Cursor := crHandPoint;
    cbxUnbezUrlaub.Caption := 'Unbezahlter Urlaub';
    cbxUnbezUrlaub.ChildOrder := 14;
    cbxUnbezUrlaub.Font.Charset := ANSI_CHARSET;
    cbxUnbezUrlaub.Font.Color := clWindowText;
    cbxUnbezUrlaub.Font.Height := -13;
    cbxUnbezUrlaub.Font.Name := 'Verdana';
    cbxUnbezUrlaub.Font.Style := [];
    cbxUnbezUrlaub.HeightPercent := 100.000000000000000000;
    cbxUnbezUrlaub.ParentFont := False;
    cbxUnbezUrlaub.WidthPercent := 100.000000000000000000;
    cbxHalbeTage.SetParentComponent(WebPanel2);
    cbxHalbeTage.Name := 'cbxHalbeTage';
    cbxHalbeTage.Left := 213;
    cbxHalbeTage.Top := 80;
    cbxHalbeTage.Width := 140;
    cbxHalbeTage.Height := 22;
    cbxHalbeTage.Cursor := crHandPoint;
    cbxHalbeTage.Caption := 'Halbe Tag(e)';
    cbxHalbeTage.ChildOrder := 14;
    cbxHalbeTage.Font.Charset := ANSI_CHARSET;
    cbxHalbeTage.Font.Color := clWindowText;
    cbxHalbeTage.Font.Height := -13;
    cbxHalbeTage.Font.Name := 'Verdana';
    cbxHalbeTage.Font.Style := [];
    cbxHalbeTage.HeightPercent := 100.000000000000000000;
    cbxHalbeTage.ParentFont := False;
    cbxHalbeTage.WidthPercent := 100.000000000000000000;
    respGrid.SetParentComponent(Self);
    respGrid.Name := 'respGrid';
    respGrid.Left := 0;
    respGrid.Top := 267;
    respGrid.Width := 580;
    respGrid.Height := 392;
    respGrid.Cursor := crHandPoint;
    respGrid.ElementClassName := 'respgrid';
    respGrid.HeightStyle := ssAuto;
    respGrid.WidthStyle := ssPercent;
    respGrid.WidthPercent := 90.000000000000000000;
    respGrid.Align := alClient;
    respGrid.ChildOrder := 3;
    respGrid.Font.Charset := ANSI_CHARSET;
    respGrid.Font.Color := clWindowText;
    respGrid.Font.Height := -13;
    respGrid.Font.Name := 'Verdana';
    respGrid.Font.Style := [];
    respGrid.ItemIndex := 0;
    respGrid.Options.ItemClassName := 'respitem';
    respGrid.Options.ItemColor := 16639703;
    respGrid.Options.ItemHeight := 50;
    respGrid.Options.ItemHoverColor := 14811135;
    respGrid.Options.ItemSelectedColor := 14811135;
    respGrid.Options.ItemPadding := 10;
    respGrid.Options.ItemWidthMin := 280;
    respGrid.ParentFont := False;
    tabSprachDaten.Left := 456;
    tabSprachDaten.Top := 168;
  finally
    WebPanel1.AfterLoadDFMValues;
    lbMaBstCaption.AfterLoadDFMValues;
    lbEntladung.AfterLoadDFMValues;
    lbMitarbeiter.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    lbStatus.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    dtBeginn.AfterLoadDFMValues;
    dtEnde.AfterLoadDFMValues;
    edtInfoText.AfterLoadDFMValues;
    cbxSchulpfKinder.AfterLoadDFMValues;
    cbxUnbezUrlaub.AfterLoadDFMValues;
    cbxHalbeTage.AfterLoadDFMValues;
    respGrid.AfterLoadDFMValues;
    tabSprachDaten.AfterLoadDFMValues;
  end;
end;

end.
